// extracted by mini-css-extract-plugin
export default {"questionsWrap":"AnswersModal_questionsWrap__+pKHL","questionContent":"AnswersModal_questionContent__xDOLM","answer":"AnswersModal_answer__JWQTr","area":"AnswersModal_area__3HWJd"};